import { ON_SEARCH_RESULTS } from '../utils/constants.js'
import { fetchResults } from '../utils/fetchResults.js'
import { scrollToContainer } from '../utils/scrollToContainer.js'

// Cottages/AreaType quick-filter pills in the DevelopmentListPage hero. This
// row sits outside `.js-fetch-container`, so the AJAX response never
// refreshes it - not on its own clicks, nor on other filter actions (e.g.
// the in-list "All homes" reset). So its state is never trusted as-is:
// clicks recompute their target from the live URL, and every search update
// re-syncs aria-current from that same URL.
export const heroFilterPillsInit = () => {
    const nav = document.querySelector('.js-hero-filter-pills')
    if (!nav) return

    const container = document.querySelector('.js-fetch-container')
    if (!container) return

    const syncPillStates = () => {
        const params = new URLSearchParams(window.location.search)
        nav.querySelectorAll('a[data-pill-param]').forEach((pill) => {
            const { pillParam, pillValue } = pill.dataset
            if (params.get(pillParam) === pillValue) {
                pill.setAttribute('aria-current', 'true')
            } else {
                pill.removeAttribute('aria-current')
            }
        })
    }

    // Covers every OTHER filter action (in-list pills, dropdowns, "All
    // homes" reset...) - none of which touch this row directly.
    container.addEventListener(ON_SEARCH_RESULTS, syncPillStates)

    nav.addEventListener('click', async (e) => {
        const link = e.target.closest('a[href]')
        if (!link || !nav.contains(link)) return

        e.preventDefault()

        const { pillParam, pillValue } = link.dataset
        const wasActive = link.getAttribute('aria-current') === 'true'

        const url = new URL(window.location.href)
        if (wasActive) {
            url.searchParams.delete(pillParam)
        } else {
            url.searchParams.set(pillParam, pillValue)
        }
        // Matches FilterURL()'s own pagination reset (ElasticListingTrait's
        // `search_pagination_page_field`, `_page_` by default) - a filter
        // change should always land back on page one of the new results.
        url.searchParams.delete('_page_')
        url.hash = 'development-list'
        const href = url.toString()

        const currentUrl = window.location.href
        window.history.pushState({}, '', href)
        syncPillStates()

        scrollToContainer(container)

        const didFetchResults = await fetchResults({ container, fetchURL: href })

        if (!didFetchResults) {
            window.history.replaceState({}, '', currentUrl)
            syncPillStates()
        }
    })
}